import { type AxiosResponse } from 'axios'
import { type Middleware } from 'swr'

/**
 * 情境：
 * 1. 當 API 200 且回傳的 data 有 error key 時，destructuredData 應該要回傳 undefined
 * 2. 當 API 200 且回傳的 data 沒有 error key 時，destructuredData 應該要回傳 data.data 或 data
 * 3. 當 API 200 且回傳的 data 是 null 表示無資料，此時有兩種回傳格式
 *    3.1 回傳 null
 *    3.2 回傳 { data: null }
 */
export const destructureData = (axiosResponse?: AxiosResponse) => {
  if (!axiosResponse) {
    return {
      destructuredData: undefined,
      responseData: undefined,
    }
  }
  const responseData = axiosResponse.data
  const responseWithDataKey = axiosResponse.data?.data
  /**
   * data 有可能不是 object 所以要用 hasOwnProperty
   */
  const isResponseWithDataKey = responseData !== null && responseData !== undefined && Object.prototype.hasOwnProperty.call(responseData, 'data')
  const destructuredData = isResponseWithDataKey ? responseWithDataKey : responseData
  return {
    destructuredData: responseData?.error ? undefined : destructuredData,
    responseData,
  }
}

export const withDestructuredResponse: Middleware = (useSWRNext) => {
  return (key, fetcher, config) => {
    const swr = useSWRNext(key, fetcher, config)

    return {
      ...swr,
      ...destructureData(swr.data as AxiosResponse),
    }
  }
}
